const $inject = [];
const lbaODataSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaODataSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaODataSelect.html')
  }
};

lbaODataSelect.$inject = $inject;

export default lbaODataSelect;



// WEBPACK FOOTER //
// ./src/components/lbaODataSelect/lbaODataSelectDir.js